import { render, staticRenderFns } from "./MatchingProduct.vue?vue&type=template&id=26433795&scoped=true&"
import script from "./MatchingProduct.vue?vue&type=script&lang=js&"
export * from "./MatchingProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26433795",
  null
  
)

export default component.exports